export enum ButtonType {
  location = 'location',
  navigation = 'navigation',
}
